import { render, staticRenderFns } from "./role-edit.vue?vue&type=template&id=e729f4b4&"
import script from "./role-edit.vue?vue&type=script&lang=js&"
export * from "./role-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e729f4b4')) {
      api.createRecord('e729f4b4', component.options)
    } else {
      api.reload('e729f4b4', component.options)
    }
    module.hot.accept("./role-edit.vue?vue&type=template&id=e729f4b4&", function () {
      api.rerender('e729f4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/usermgmt/role-edit.vue"
export default component.exports